export default {
  title: "Order Form",
  detail: "Create or edit an order for customers",
  back: "Back",
  saving: "Saving...",
  save: "Save",
  success: "Operation Successful",
  error: "Error",
  networkError: "Network Error",

  customer: "Customer",
  placeholderCustomer: "Search customer (name or mobile)",
  status: "Order Status",
  statusRegistered: 'registered',
  statusApproved: 'approved',
  statusRejected: 'rejected',

  shippingMethod: "Shipping Method",
  placeholderShippingMethod: "Select shipping method",
  paymentMethod: "Payment Method",
  placeholderPaymentMethod: "Select payment method",
  address: "Address",
  selectAddress: "Select address",
  addressDetails: "Address Details",
  addressTitle: "Address Title",
  addressPhone: "Address Phone",
  postalCode: "Postal Code",
  fullAddress: "Full Address",
  addressExtraDetails: "Additional Details",
  emptyAddress: "Empty address",

  items: "Items",
  addItem: "Add Item",
  product: "Product",
  placeholderProduct: "Search product (name)",
  quantity: "Quantity",
  price: "Unit Price",
  subtotal: "Subtotal",
  discount: "Discount",
  itemDiscount: "Manual Discount",
  discountPaymentMethod: "Payment Method Discount",
  shippingCost: "Shipping Cost",
  tax: "Tax",
  summary: "Invoice Summary",
  totalDiscount: "Total Discount",
  totalPrice: "Total Price",
  total: "Total",
  calculating: "Calculating invoice...",
};
